import { render, staticRenderFns } from "./ArticoloVarianti.vue?vue&type=template&id=20429f36&scoped=true&"
import script from "./ArticoloVarianti.vue?vue&type=script&lang=js&"
export * from "./ArticoloVarianti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20429f36",
  null
  
)

export default component.exports